
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import { AppParameterDto, UpsertAppParameterRequest } from "@/types";

export default defineComponent({
  name: "ConfigParameterScreen",
  setup() {
    const { axios, success, error, setLoading } = usePlugin();
    const config = ref<AppParameterDto>({
      noApproverLevel: 0,
    });

    const loadParameters = async () => {
      setLoading(true);
      try {
        const result = await axios.post<AppParameterDto>(
          "api/v1/services/configParameter/get"
        );
        success("ดึงข้อมูลสำเร็จแล้ว");
        config.value = result.data;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onSaveParameter = async () => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/configParameter/upsert", {
          parameter: config.value,
        } as UpsertAppParameterRequest);
        success("บันทึกข้อมูลสำเร็จแล้ว");
        await loadParameters();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(() => loadParameters());
    return {
      config,
      onSaveParameter,
    };
  },
});
